import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from "../../navigation/LoadingIcon";

const SuspenseWithLoading = ({ children, size = 150 }) => {
    return (
        <Suspense fallback={
            <div className="flex items-center justify-center h-full w-full">
                <LoadingIcon size={size} />
            </div>
        }>
            {children}
        </Suspense>
    );
};

SuspenseWithLoading.propTypes = {
    children: PropTypes.node.isRequired,
    size: PropTypes.number
};

export default SuspenseWithLoading;